import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import * as $ from 'jquery';
import {TweenLite, Power2} from 'gsap';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { Router, ActivationEnd } from '@angular/router';
import { HostListener } from '@angular/core';

let  menueOpen: Boolean = false
    , setSizeMenue: Boolean = false
    , __this: any;

@Component({
  selector: 'app-navi',
  templateUrl: './navi.component.html',
  styleUrls: ['./navi.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        height: '*'
      })),
      state('closed', style({
        height: '0px'
      })),
      transition('open => closed', [
        animate('0.25s ease-in-out')
      ]),
      transition('closed => open', [
        animate('0.25s ease-in-out')
      ]),
    ]),
  ]
})


export class NaviComponent implements OnInit {
  isOpenEx = false;
  isOpenArt = false;
  __this = this;

  _leftPos=350;
  
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    this.sizeNavi()
  }

  
  constructor(
    private router: Router,
    private elementRef: ElementRef
  ) {

    TweenLite.to( $('body,html') , 0, {scrollTop: 0 });

    this.router.events.subscribe(event => {
      this.isOpenArt = false;
      this.isOpenEx = false;

      if (event instanceof ActivationEnd) {

        TweenLite.to( $('body,html') , 0.5, {scrollTop: 0 , ease: Power2.easeInOut } );

        $('#navi-ul > li').each( function(__obj: Number) {
          const f: any = $(this);
          $( this ).find('a').removeClass( 'activeYellow' );
        });

        if (event.snapshot.url.length > 0) {
          $('html').attr('style' , 'background-color:#fFFFFFF');
          $('body').attr('style' , 'background-color:#fFFFFFF');

          const spl = event.snapshot.url[0].path;
          $('#navi-ul > li').each( function(__obj: Number) {
            const f: any = $(this);
            if ( f.find('a').attr('data-ref') !== undefined && f.find('a').attr('data-ref') === spl ) {
              $( this ).find('a[data-ref=' + spl + ']').addClass( 'activeYellow' );
            }
          });
          if (spl === 'art-projects') {
            setTimeout( () => this.isOpenArt = !this.isOpenArt , 10);
          }
          if (spl === 'exhibition') {
            setTimeout( () => this.isOpenEx = !this.isOpenEx , 10);
          }
        } else {
          $('html').attr('style' , 'background-color:#ffd800');
          $('body').attr('style' , 'background-color:#ffd800');
        }
      }
    });


    // const targetNode = $('#tester')[0];
    // const element = targetNode;

    // this.changes = new MutationObserver((mutations: MutationRecord[]) => {
    //       console.log( "DDD" );
    //       //mutations.forEach((mutation: MutationRecord) => this.domChange.emit(mutation));
    //     }
    // );

    // this.changes.observe(element, {
    //   attributes: true,
    //   childList: true,
    //   characterData: true
    // });


  }


  ngOnInit() {

    // set OnClick function
    let _this: any = this;
    this.menueOpenClose( 'close' );
    $('#navi-ul > li a').each( function(__obj: Number) {
      const ob = $( this );
      if ( !ob.hasClass('pullD') ) {
        ob.click( function() {
          _this.menueOpenClose( 'close' );
          // $(this).find('a').addClass('active');
        });
      } else {
        ob.click( function(event) {
          if ($(event.currentTarget).hasClass( 'art' ) ) {
            _this.isOpenArt = !_this.isOpenArt;
            _this.isOpenEx = false;
          } else if ($(event.currentTarget).hasClass( 'ex' ) ) {
            _this.isOpenEx = !_this.isOpenEx;
            _this.isOpenArt = false;
          }
        });
      }
    });

    this._leftPos = 0;
    this.posChceck();
  }

  onResize(event) {
    this.posChceck();
    this.sizeNavi();
  }

  sizeNavi(){
    const naviBound = $('#navi-ul')[0].getBoundingClientRect();
    const naviHeight = parseInt($('.mposscro').css('marginTop')) + naviBound.height;

    if (window.innerHeight < naviHeight){
      if ($('#wrapper')) {
        $('#navi').css('position', 'absolute');
        $('#navi').css('height', $('#wrapper')[0].getBoundingClientRect().height+"px" );
      }
    }else{
      $('#navi').css('height', '100vh');
      $('#navi').css('position', 'fixed');
    }
  }

  posChceck() {
    const p = parseInt($('.menue-liste').css('width'));
    if (this._leftPos !== p) {
      this._leftPos = p;
      this.menueOpenClose( 'close' );
    }
  }

  menueOpenClose = function( __evt ) {
    const ww = parseInt( $('.menue-liste').css('width') );
    if ( __evt == 'close' ) {
      menueOpen = true;
    }
    if ( menueOpen == true ) {
        TweenLite.to( $('.balken:first-child') , 0.05, {alpha: 1, rotation: 0, y: '0px', transformOrigin: '44% 50%' });
        TweenLite.to( $('.balken:last-child') , 0.05, {alpha: 1, rotation: 0, y: '0px', transformOrigin: '40% 50%'});
        TweenLite.to( $('.balken.middle') , 0.05, {alpha: 1 });

        TweenLite.to( $('#navi') , 0.15, { left: (-ww), ease: Power2.easeInOut });

        TweenLite.to( $('#menue-mobile') , 0.15, { css: {left: (ww) + 'px'}, ease: Power2.easeInOut });

        menueOpen = false;
    } else {
        TweenLite.to( $('.balken:first-child') , 0.05, {alpha: 1, rotation: 40, y: '9px', transformOrigin: '44% 50%' });
        TweenLite.to( $('.balken:last-child') , 0.05, {alpha: 1, rotation: -40, y: '-8px', transformOrigin: '40% 50%' });
        TweenLite.to( $('.balken.middle') , 0.05, {alpha: 0 });
        TweenLite.to( $('#navi') , 0.15, { left: 0, ease: Power2.easeInOut });


        TweenLite.to( $('#menue-mobile') , 0.15, { css: {left: (ww) + 'px'}, ease: Power2.easeInOut  });

        menueOpen = true;
    }

  };

}
